import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import { IoAdd } from 'react-icons/io5';
import { ITitleTopics } from '../../../../services/hooks/Titles/useGetTitlesTopicsData';
import FormTitleContent from './FormTitleContent';
import { ITitleTypeAndRulesProps } from '../../../../services/hooks/Titles/useGetTitleTypesAndRules';

interface IOwnProps {
  topic: ITitleTopics;
  registrationId: string;
  stepId: string;
  refetchData(): void;
  rules: ITitleTypeAndRulesProps;
}

const FormTitleButton: React.FC<IOwnProps> = ({ topic, registrationId, stepId, refetchData, rules }) => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');

  const disclosureModal = useDisclosure();

  const closeModal = () => {
    disclosureModal.onClose();
  };

  return (
    <>
      <Button
        size={isMobile ? 'sm' : 'md'}
        onClick={disclosureModal.onOpen}
        w={'fit-content'}
        leftIcon={<IoAdd />}
        colorScheme="green"
      >
        Enviar arquivo
      </Button>

      {isMobile && (
        <Drawer placement={'bottom'} isOpen={disclosureModal.isOpen} onClose={disclosureModal.onClose}>
          <DrawerOverlay />

          <DrawerContent maxH={'90%'}>
            <DrawerBody p={0}>
              <FormTitleContent
                rules={rules}
                refetchData={refetchData}
                closeModal={closeModal}
                registrationId={registrationId}
                stepId={stepId}
                topic={topic}
              />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {!isMobile && (
        <Modal isOpen={disclosureModal.isOpen} onClose={disclosureModal.onClose} isCentered>
          <ModalOverlay />
          <ModalContent pb={10} maxW={'90%'} minH="90%">
            <ModalBody display="flex" flexDir="column" gap={1}>
              <FormTitleContent
                rules={rules}
                refetchData={refetchData}
                closeModal={closeModal}
                registrationId={registrationId}
                stepId={stepId}
                topic={topic}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default FormTitleButton;
